// extracted by mini-css-extract-plugin
export var background = "g_x";
export var container = "g_h";
export var hide = "g_z";
export var scrolled = "g_y";